<script lang="ts">
    import Icon from "@components_v2/Icon.svelte";
    import StatusActiveIcon from "@components_v2/Icons/StatusActiveIcon.svelte";

    import T from "@components/T.svelte";
    import TooltipActivator from "@components/Tooltip/TooltipActivator.svelte";

    export let namespace: string;
    export let isVerifiedBuyer: boolean;
    export let isVerifiedBuyerByMerchant: boolean;
</script>

<TooltipActivator position="bottom-start">
    <svelte:fragment>
        <Icon class="gw-rv-meta__icon" width={20} height={20}>
            <StatusActiveIcon />
        </Icon>
    </svelte:fragment>

    <svelte:fragment slot="content">
        {#if isVerifiedBuyer}
            <T {namespace} translationKey="verified_buyer" />
        {:else if isVerifiedBuyerByMerchant}
            <T {namespace} translationKey="verified_by_merchant" />
        {/if}
    </svelte:fragment>
</TooltipActivator>

<style lang="postcss">
    .gw-rv-meta {
        :global(&__icon) {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: box-shadow 0.2s ease;
            border-radius: 50%;

            &:hover {
                box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
                background: rgba(0, 0, 0, 0.05);
            }
        }
    }
</style>
